import {Feature, FeatureCollection, Geometry} from "geojson";
import bbox from "@turf/bbox";
import {LngLatBoundsLike} from "mapbox-gl";

export function bounds(feature: Feature | Geometry) {
    return bbox(feature) as LngLatBoundsLike
}

export function featureCollection(features: Array<Feature>): FeatureCollection {
    return {type: 'FeatureCollection', features}
}

export function feature(id: number | string, properties: object, geometry: Geometry): Feature {
    return {type: 'Feature', id, properties: {...properties, id}, geometry}
}

export function metersToPixelsAtMaxZoom(meters: number, latitude: number) {
    return meters / 0.075 / Math.cos(latitude * Math.PI / 180)
}